import { DeviceType } from '../api-clients/_api';

export const peripheralDeviceTypes = Object.keys(DeviceType).map((key) => DeviceType[key]);

export const formattedPeripheralDeviceNames = peripheralDeviceTypes.reduce((acc, deviceType) => {
  let formattedDeviceName = deviceType.replace('_', ' ').toUpperCase();
  if (deviceType === DeviceType.NOVOS3) {
    formattedDeviceName = 'NOVOS 3';
  }

  acc[deviceType] = formattedDeviceName;

  return acc;
}, {});

export const formatPeripheralDescription = (zoneId: string, deviceType: string) => {
  if (!zoneId) {
    return deviceType;
  }
  const removeUnderscoreFromZoneId = zoneId?.replace('_', ' ');

  return `${removeUnderscoreFromZoneId?.replace(/(^\w{1})|(\s{1}\w{1})/g, (match) => match.toUpperCase())} - ${
    formattedPeripheralDeviceNames[deviceType]
  }`;
};
